import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import * as $ from 'jquery';
import { RolesListComponent } from './roles-list.component';
import { RolesService } from './roles.service';
import { IRol } from './rol';
import * as myGlobals from './../global';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthService } from '../services/auth.service';
import { HttpErrorValidator } from '../services/http-error-validator';

@Component({
  selector: 'pm-roles',
  templateUrl: './roles.component.html',
  styleUrls: ['./roles.component.sass']
})
export class RolesComponent implements OnInit, OnDestroy, AfterViewInit {
  roles: IRol[] = [];
  errorMessage = '';
  currentPg = 1;

  constructor(
    public service: RolesService,
    private parent: RolesListComponent,
    private router: Router,
    private spinnerService: NgxSpinnerService,
    private httpErrorValidator: HttpErrorValidator
  ) {}

  ngAfterViewInit() {
    $('a[rel=roles]').addClass('selected');
  }

  newRol(): void {
    this.parent.showEditRol = false;
    this.parent.showRoles = false;
    this.parent.showAddRol = true;
    this.parent.showEditRolPermissions = false;
  }

  ngOnInit(): void {
    this.service.getRoles().subscribe(res => (this.roles = res), err => this.httpErrorValidator.validateError(err));
    this.spinner();
  }

  edit(elemento, index: number) {
    // this.parent.editnumber = index;
    // console.log(this.parent.editnumber+","+index);
    // console.log(elemento.roles[index]);
    this.parent.editnumber = elemento.roles[index].id;
    this.parent.showRoles = false;
    this.parent.showAddRol = false;
    this.parent.showEditRol = true;
    this.parent.showEditRolPermissions = false;
  }

  editpermissions(roleId: number) {
    this.parent.editnumber = roleId;
    this.parent.showRoles = false;
    this.parent.showAddRol = false;
    this.parent.showEditRol = false;
    this.parent.showEditRolPermissions = true;
  }

  public spinner(): void {
    this.spinnerService.show();
    setTimeout(() => {
      this.spinnerService.hide();
    }, 300);
  }

  public ngOnDestroy(): void {
    $('a[rel=roles]').removeClass('selected');
  }
}
